import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';

@Component({
  selector: 'card-locked',
  templateUrl: './card-locked.component.html',
  styleUrls: ['./card-locked.component.scss']
})
export class CardLockedComponent {
  constructor(private store: Store<AppState>) {}

  public onGoToBolsaClick() {
    const events = {
      'Product Area Origin': 'Home',
      'Status': 'Aberta',
      'Element': 'Botão Ir para a Bolsa',
      'Group': 'Confira os ativos mais investidos',
      'Time Responsável': 'Sky',
    };
    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: {
        type: ActionEventsEnum.ELEMENT_CLICKED,
        events,
      },
    });
  }
}
